import { isComponentEntity, type Entity } from '@backstage/catalog-model';
import { isComponentType } from '@backstage/plugin-catalog';

/** Components other than documentation get the full component page. */
export const isFullComponent = (entity: Entity) =>
  isComponentEntity(entity) && !isComponentType('documentation')(entity);
